// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  versionNo:'1.0.Oct.06.2022',
  GOOGLE_KEY: 'AIzaSyC-_X985YnPXOeDchKKO5A0VBoliZERR2w',
  baseUrl: 'https://staging.wespni.net:9055',
  // baseUrl: 'http://staging.wespni.net:30010'
  // baseUrl: 'http://localhost:3200',
  // baseUrl: 'https://staging.wespni.net:9002',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

